import 'style/product-single.scss';
import Popup from "./components/Popup";

$(document).ready(() => {

  new Popup().init();

});



// WEBPACK FOOTER //
// ./static/js/productSingle.js